@if (state.showingBackgroundPicker()) {
  <div class="atmos-card">
    <div class="atmos-card__header">
      <h2 class="atmos-section__title">Background</h2>
    </div>
    <div class="atmos-card__body">
      <div class="atmos-bg-picker">
        @for (section of sections; track section.guid) {
          <div class="atmos-bg-picker__section-label">{{ section.label }}</div>
          <div class="atmos-bg-picker__items">
            <img src="/assets/game/background/random.webp"
              class="atmos-bg-picker__item"
              [class.is-selected]="selected() === section.guid"
              (click)="select(section.guid)" />
            @for (bg of section.backgrounds; track bg.guid) {
              <img [src]="bg.url"
                class="atmos-bg-picker__item"
                [class.is-selected]="selected() === bg.guid"
                (click)="select(bg.guid)" />
            }
          </div>
        }
      </div>
    </div>
  </div>
}
